<template>
  <div class="order-title">
    {{ $t('Título') }}:
    <router-link :to="createOrderTitleLink('+')"
      :class="[ queryOrder ==  'titulo+' ? 'active' : '']"><i class="fa fa-sort-alpha-asc"></i></router-link>
    <span>|</span>
    <router-link :to="createOrderTitleLink('-')"
      :class="[ queryOrder ==  'titulo-' ? 'active' : '']"><i class="fa fa-sort-alpha-desc"></i></router-link>
    
  </div>
</template>

<i18n>
{
  "es": {
    "Título": "Título"
  },
  "en": {
    "Título": "Title"  
  },
  "ca": {
    "Título": "Títol"
  }
}
</i18n>

<script>
  import { mapGetters } from 'vuex';

	export default {
		data: () => {
			return{
        order: 'precio+'
			}
		},
    computed:{
      ...mapGetters({ query: 'getQuery' }),
      queryOrder: function(){
        var tmp = Object.assign({}, this.query);
        return tmp.orden;
      }
    },
    methods: {
      createOrderTitleLink(option){
        var tmp = Object.assign({}, this.query);
        return ( { query: Object.assign(tmp, { orden: 'titulo'+option }) } );
      }
    },
    watch: {
      /*resultsPerPage: function() { 
        this.resultsPerPage = this.getResultsPerPage;
      }*/
    }
  }
</script>
